import {
  green100,
  green800,
  whiteAlpha800,
  whiteBase,
} from '@mentimeter/ragnar-colors';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Clickable } from '@mentimeter/ragnar-ui/clickable';
import { PopoverDismiss } from '@mentimeter/ragnar-ui/popover';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Light } from '@mentimeter/ragnar-ui/themes';
import { CrossIcon, StarSolidIcon } from '@mentimeter/ragnar-visuals';

export function PopoverHeader({
  badge,
  onDismissClick,
  children,
}: {
  badge?: 'pro' | 'basic' | undefined;
  onDismissClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <Box className="w-full px-6 pt-6">
      {badge && (
        <Box className="mb-3">
          <PopoverBadge variant={badge} />
        </Box>
      )}

      <PopoverTitle>{children}</PopoverTitle>

      <PopoverDismiss>
        <Clickable
          className="absolute top-0 right-0 p-2 z-1"
          onClick={onDismissClick}
        >
          <CrossIcon color={whiteBase} size={2} />
        </Clickable>
      </PopoverDismiss>
    </Box>
  );
}

export function PopoverTitle({ children }: { children: React.ReactNode }) {
  return (
    <Text
      as="h2"
      className="text-text text-125 font-heading leading-snug"
      id="ragnar-popover-title"
      color={whiteBase}
    >
      {children}
    </Text>
  );
}

export function PopoverBadge({ variant }: { variant: 'pro' | 'basic' }) {
  return (
    <Box
      as="span"
      className="px-2 py-1 rounded-full flex flex-row"
      bg={green800}
    >
      <Box mr="space1">
        <StarSolidIcon size={1} color={green100} />
      </Box>
      <Text fontSize="62.5" fontWeight="semiBold" color={green100}>
        {variant === 'pro' ? 'Pro' : 'Basic'}
      </Text>
    </Box>
  );
}

export function PopoverBody({ children }: { children: React.ReactNode }) {
  return <Box className="w-full px-6 pt-2 pb-4">{children}</Box>;
}

export function PopoverDescription({
  children,
}: {
  children: React.ReactNode;
}) {
  return <Text color={whiteAlpha800}>{children}</Text>;
}

export function PopoverFooter({ children }: { children: React.ReactNode }) {
  return (
    <Light>
      <Box className="w-full justify-end px-4 pb-4 gap-2 flex-col-reverse sm:flex-row items-stretch sm:items-center">
        {children}
      </Box>
    </Light>
  );
}
